import React, { useEffect, useState } from 'react';
import { Row, Col, Skeleton } from 'antd';
import api from '../../services/api';

// Card "Essa semana rolou" — metricas agregadas dos ultimos 7 dias.
// Mantem o feed vivo mesmo em periodos de baixa entrada de cadastros.
// Cacheado no backend (30s), leve, atualiza automatico.

const METRICS = [
  { key: 'goals',            emoji: '🥅', label: 'Gols',        color: '#25D366' },
  { key: 'players_rated',    emoji: '⭐', label: 'Avaliados',   color: '#faad14' },
  { key: 'games',            emoji: '⚽', label: 'Peladas',     color: '#1890ff' },
  { key: 'calls',            emoji: '📢', label: 'Convocações', color: '#fa8c16' },
  { key: 'mvps',             emoji: '🏆', label: 'MVPs',        color: '#722ed1' },
  { key: 'new_players',      emoji: '👥', label: 'Novos',       color: '#13c2c2' },
];

export default function CommunityHighlights() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get('/community/feed/highlights')
      .then(r => { if (alive) setData(r.data); })
      .catch(() => { /* silencia — nao aparece card se falhar */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  if (!loading && !data) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #128C7E 0%, #25D366 100%)',
      borderRadius: 16, padding: 20, marginBottom: 16,
      color: '#fff', boxShadow: '0 8px 24px rgba(37, 211, 102, 0.25)',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.4,
        backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'><path d='M40 0H0v40' fill='none' stroke='rgba(255,255,255,0.08)' stroke-width='1'/></svg>\")",
      }} />
      <div style={{ position: 'relative' }}>
        <div style={{ fontSize: 13, opacity: 0.9, fontWeight: 500, marginBottom: 4 }}>
          Essa semana rolou na comunidade
        </div>

        {loading ? (
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        ) : (
          <Row gutter={[16, 12]}>
            {METRICS.map(m => {
              const v = data[m.key] || 0;
              if (v === 0) return null; // esconde zerados pra nao poluir
              return (
                <Col key={m.key} xs={12} sm={8} md={4}>
                  <div style={{
                    background: 'rgba(255,255,255,0.15)', borderRadius: 12,
                    padding: '10px 8px', textAlign: 'center',
                    backdropFilter: 'blur(4px)',
                    minHeight: 88,
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                  }}>
                    <div style={{ fontSize: 20, lineHeight: 1 }}>{m.emoji}</div>
                    <div style={{ fontSize: 22, fontWeight: 800, lineHeight: 1.1, marginTop: 4 }}>
                      {v.toLocaleString('pt-BR')}
                    </div>
                    <div style={{
                      fontSize: 11, opacity: 0.95, marginTop: 2, fontWeight: 500,
                      whiteSpace: 'nowrap',
                    }}>
                      {m.label}
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </div>
    </div>
  );
}
